// extracted by mini-css-extract-plugin
export default {"container":"Login_container__x4rTU","innerBox":"Login_innerBox__bC4TY","heading":"Login_heading__qL7QN","footer":"Login_footer__gb6XA","error":"Login_error__WEcKA"};